firebird.factory('configService', [
    'logService',
    'helperService',
    'storageService',
    function (logService, helperService, storageService) {
        var service = {
            readStorage: readStorage,
            getClientValue: getClientValue,
            getServerValue: getServerValue,
            getValue: getValue,
            setSfuPayload: setSfuPayload,
            getSfuPayload: getSfuPayload,
            getHasMultishare: getHasMultishare,
            getMultisharePrompt: getMultisharePrompt,
            isLayoutLockAvailable: isLayoutLockAvailable,
            isLayoutLockLocked: isLayoutLockLocked,
            getHasFeatureFlags: getHasFeatureFlags
        };

        var settings = null; // from local storage
        var sfuPayload = {}; // from user pairs

        const logger = new LogServiceWrapper(logService, '[configService]');

        return service;

        ////////////////////////

        function readStorage(meetingCode) {
            // delete advancedSettings if not saved for all meetings, and this is a different meeting.
            var box = JSON.parse(storageService.get('advancedSettingsBox') || '{}');
            if (box.meeting && meetingCode && box.meeting != meetingCode) {
                logger.log(
                    'readStorage',
                    'delete advancedSettings as for different meeting ' + box.meeting + ' != ' + meetingCode
                );
                storageService.remove('advancedSettings');
            }

            settings = JSON.parse(storageService.get('advancedSettings') || '{}');
            return settings;
        }

        function getClientValue(attr) {
            return helperService.getQueryParameter(attr) || (settings || {})[attr] || null;
        }

        function getServerValue(attr) {
            return (sfuPayload || {})[attr] || null;
        }

        function getValue(attr) {
            return getClientValue(attr) || getServerValue(attr);
        }

        function setSfuPayload(newSfuPayload) {
            sfuPayload = newSfuPayload;
        }

        function getSfuPayload() {
            return sfuPayload || {};
        }

        function getHasMultishare() {
            return '' + service.getServerValue('multishare') == 'true';
        }

        function getMultisharePrompt() {
            return '' + service.getServerValue('multisharePrompt') === null
                ? 'true'
                : service.getServerValue('multisharePrompt'); // default is true
        }

        function isLayoutLockAvailable() {
            return service.getServerValue('layoutLock') != 'false';
        }

        function isLayoutLockLocked() {
            return service.getServerValue('layoutLock') == 'locked';
        }

        function getHasFeatureFlags() {
            return (service.getServerValue('featureFlags') || 'false') != 'false';
        }
    }
]);
